module.exports = __webpack_public_path__ + "static/media/Purchase5.4ff8a426.png";